<template>
  <span class="" id="scale-line"></span>
</template>

<script>

import ScaleLineControl from 'ol/control/ScaleLine'

export default {
  data: () => ({
    control: null
  }),
  mounted () {
    this.control = new ScaleLineControl({
      className: 'ol-scale-line',
      target: 'scale-line'
    })
    this.$map.addControl(this.control)
  }
}
</script>

<style lang="stylus">
#scale-line
  .ol-scale-line
    position: relative
    display: inline-block
    background: transparent
    bottom: 0
    left: 0
    line-height: 10px
</style>
